module.exports = __webpack_public_path__ + "static/media/right.b35dfe8b.png";